import { assign, reduce } from 'lodash';

import { EntityBase } from './EntityBase';
import { AppConstants } from '~/shared/utils/app-constants';

export interface PropertyMetricJSON {
  propertyId: number;
  propertyName: string;
  zipCode: string;
  address: string;
  city: string;
  state: string;
  averageSquareFootage: number;
  stories: number;
  stable: string;
  class: string;
  latitude: string;
  longitude: string;
  imageHero: string;
  heroSource: string;
  marketName: string;
  submarketName: string;
  type: string;

  metricData: PropertyMetricDataJSON[];
}

export interface PropertyMetricDataJSON {
  metricCode: string;
  metricValue: number;
  metricValueFormatted: string;
}

export interface RentMetric {
  askingRent?: PropertyMetricDataJSON;
  askingRentPerSquareFoot?: PropertyMetricDataJSON;
  effectiveRent?: PropertyMetricDataJSON;
  effectiveRentPerSquareFoot?: PropertyMetricDataJSON;
  annualRentChange?: PropertyMetricDataJSON;

  concessions?: PropertyMetricDataJSON;
  occupancy?: PropertyMetricDataJSON;
}

const RentMetricMapping: { [k: string]: keyof RentMetric } = {
  'MPF-HIST-ASK-RENT': 'askingRent',
  'MPF-HIST-AVG-ASK-RPSF': 'askingRentPerSquareFoot',
  'MPF-RENT': 'effectiveRent',
  'MPF-RPSF': 'effectiveRentPerSquareFoot',
  'MPF-ANN-RENT-CHG': 'annualRentChange',
  'MPF-OCC': 'occupancy',
  'MPF-HIST-CONC-RATIO': 'concessions',
  // SH
  'SH-HIST-ASK-RENT-PB': 'askingRent',
  'SH-HIST-AVG-ASK-RPSF-PB': 'askingRentPerSquareFoot',
  'SH-HIST-RENT-PB': 'effectiveRent',
  'SH-HIST-RPSF-PB': 'effectiveRentPerSquareFoot',
  'SH-HIST-ANN-RENT-PB-CHG': 'annualRentChange',
  'SH-HIST-OCCUPANCY': 'occupancy',
  'SH-HIST-CONC-RATIO-PB': 'concessions'
}

export interface PropertyMetric extends PropertyMetricJSON {
  metrics: RentMetric;

  coordinate: {
    latitude: number,
    longitude: number
  };
}

export class PropertyMetric extends EntityBase {
  constructor(json: PropertyMetricJSON) {
    super(json);

    this.id = this.propertyId;
    this.stories = +this.stories;

    if(this.type === AppConstants.TYPES.STUDENT_HOUSING) {
      this.propertyName = `${this.propertyName} *`;
      this.class = '';
    }

    this.coordinate = {
      latitude: +this.latitude,
      longitude: +this.longitude
    };

    this.metrics = json && json.metricData
      ? reduce(json.metricData, (all, metric) => assign(all, { [RentMetricMapping[metric.metricCode]]: metric }), {})
      : {};
  }
}



// WEBPACK FOOTER //
// ./src/app/core/model/PropertyMetric.ts